var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalFormGeneric',{ref:_vm.COMPNAME,attrs:{"id":_vm.COMPNAME,"title":_vm.$t('lgout.t'),"btnText":_vm.$t('lgout.b'),"btnIcon":"lgo"},on:{"submit":_vm.onSubmit,"reset":function($event){return _vm.$emit('reset')}}})}
var staticRenderFns = []

export { render, staticRenderFns }